import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/rope_picking_boats`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/rope_picking_boats/${itemId}`, payload);
  },

  updateOrders(portId, payload) {
    return http.put(`${resource}/${portId}/rope_picking_boats/sorts`, payload);
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/rope_picking_boats`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/rope_picking_boats/${itemId}`);
  },
};
